String.prototype.rtrim = function(charlist) {
  if (charlist === undefined) {
    charlist = " "
  }

  return this.replace(new RegExp("[" + charlist + "]+$"), "")
}

export const isMobileQuery = window.matchMedia("(max-width: 576px)")
export const isPrintQuery = window.matchMedia("print")

export const getFormfieldIcon = el => {
  const iconClasses = [...el.classList.toString().matchAll("formfield-(icon-\\S+)")].map(match => match[1])

  if (iconClasses.length) {
    const iconEl = document.createElement("i")
    iconEl.classList.add(...iconClasses)
    iconEl.classList.add("formfield-icon")
    iconEl.setAttribute("aria-hidden", true)
    return iconEl
  }

  return null
}
